import React from 'react';
import SolutionsIndex from '../../../pages/SolutionsIndex';
import SolutionPage from '../../../pages/SolutionPage';

export const solutionsRoutes = [
  { path: '/solutions', element: <SolutionsIndex /> },
  { path: '/solutions/:slug', element: <SolutionPage /> }
];
